<template>
    <div class="dfRegion clearfix" :class="[settings.cssClass, colClass]" :style="{ 'padding-left': settings.indent ? settings.indent : null }">
        <span v-html="settings.htmlContent" v-show="settings.htmlContent"></span>
        <ChildrenList :children-ids="children" :view-only="isViewOnly"></ChildrenList>
        <ErrorList :data="data" />
        <AdminSettingsDifferences :data="data" />
    </div>
</template>
<script lang="ts">
import { defineComponent } from "vue";
import { props, Props, components, setup } from "./BaseDefMixin.3";
import type { RegionSettings } from "@/cs-ts-bridge/ts/region-settings";
import type RegionDef from "../elements/RegionDef";
export default defineComponent({
    components: {
        ...components,
    },
    props: props,
    //@ts-ignore
    setup(props: Props<RegionDef, RegionSettings>) {
        const base = setup<RegionDef, RegionSettings>(props);
        return { ...base.expose };
    },
});
</script>
